import { render, staticRenderFns } from "./application-review.vue?vue&type=template&id=1c54ec47&scoped=true"
import script from "./application-review.vue?vue&type=script&lang=js"
export * from "./application-review.vue?vue&type=script&lang=js"
import style0 from "./application-review.vue?vue&type=style&index=0&id=1c54ec47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54ec47",
  null
  
)

export default component.exports